import * as types from './actionTypes.mobileSpecificBehaviour';

export const showMobileWarning = () => ({
    type: types.SHOW_MOBILE_WARNING_REQ,
});

export const hideMobileWarning = () => ({
    type: types.HIDE_MOBILE_WARNING_OK,
});